import { Component, inject, model } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export type ModalCancellationHistoryReturnType = string;

@Component({
  selector: 'app-modal-cancellation-history',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatDialogClose,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  templateUrl: './modal-cancellation-history.component.html',
  styleUrl: './modal-cancellation-history.component.scss',
})
export class ModalCancellationHistoryComponent {
  reason = model<ModalCancellationHistoryReturnType>('');

  readonly dialogRef = inject<
    MatDialogRef<
      ModalCancellationHistoryComponent,
      ModalCancellationHistoryReturnType
    >
  >(
    MatDialogRef<
      ModalCancellationHistoryComponent,
      ModalCancellationHistoryReturnType
    >,
  );

  onNoClick(): void {
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close(this.reason());
  }
}
